import React, { useState, Fragment, useEffect } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { updateBrokerConnectDataWithoutSave } from '@actions/brokerConnect/brokerConnectActionCreators';
import { formatNumber, validPhoneNUmber } from '@utils/miscellaneous/phoneNumberUtils';

const InputPhoneNumber = props => {
    const { phoneNumber, actions, errorHandler, id } = props;
    const [ newPhoneNumber, setNewPhoneNumber ] = useState('');

    useEffect( ()=> {
        if(newPhoneNumber !=='') {
            const noDashNumber = newPhoneNumber.replace(/[-]/g, '');
            actions.updateBrokerConnectDataWithoutSave({ ...props, tempPhoneNumber: noDashNumber });  
        }
    }, [ newPhoneNumber ]);


    return(
        <Fragment>
            <input id={id} className="gi-regular_input__input" placeholder={ formatNumber(phoneNumber) } value={ newPhoneNumber } onInput={ errorHandler } onChange={ () => validPhoneNUmber(newPhoneNumber, setNewPhoneNumber) } />
        </Fragment>
    );
};

const matchDispatchToProps = dispatch => ({    
    actions: bindActionCreators({
        updateBrokerConnectDataWithoutSave
    }, dispatch)
});

export default connect(null, matchDispatchToProps)(InputPhoneNumber);